import * as React from 'react';
import { Modal, Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip, Paper } from '@mui/material';
import { connect } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { MainInputLabel, main_button, StyledInput, centered_flex_box, sec_button, confirm_button, reject_button, ter_button, MainInput, SecInput } from '../../../app/components/Styles';
import { createUsher, getUshers } from '../../../app/store/actions/adminActions';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { motion } from 'framer-motion';

export const AddUsherModal = ({ open, handleClose, event, wait, createUsher, getUshers, action, setAction }) => {

    function timeout(delay) {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        var formData = new FormData(e.currentTarget)
        var info = {
            username: formData.get("username"),
            password: formData.get("password"),
            eventId: event._id,
            gate: formData.get("gate")
        }
        createUsher(info, handleClose)
        await timeout(500)
        setAction(!action)
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    backdropFilter: 'blur(4px)'
                }
            }}
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95vw', sm: '500px' },
                maxWidth: '95vw',
                maxHeight: '90vh',
                outline: 'none'
            }}>
                {wait.isLoading && (
                    <Paper
                        elevation={8}
                        sx={{
                            ...centered_flex_box,
                            minHeight: "50vh",
                            p: 4,
                            borderRadius: 3,
                            backgroundColor: 'var(--platform-surface)',
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        <CircularProgress 
                            size={60}
                            sx={{ 
                                color: "var(--primaryPurple)",
                                mb: 2
                            }} 
                        />
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                color: "var(--primaryPurple)",
                                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif'
                            }}
                        >
                            Adding Usher...
                        </Typography>
                    </Paper>
                )}
                {!wait.isLoading && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, y: 50 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                    >
                        <Paper
                            elevation={12}
                            sx={{
                                p: { xs: 2, sm: 5 },
                                borderRadius: 4,
                                backgroundColor: 'var(--platform-surface)',
                                border: '1px solid #e0e0e0',
                                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                    width: '6px'
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: '#f1f1f1',
                                    borderRadius: '3px'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'var(--primaryPurple)',
                                    borderRadius: '3px'
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Avatar 
                                    sx={{ 
                                        m: 2, 
                                        bgcolor: 'var(--primaryPurple)',
                                        width: { xs: 56, sm: 80 },
                                        height: { xs: 56, sm: 80 },
                                        boxShadow: '0 8px 24px rgba(95, 53, 184, 0.3)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '2.5rem',
                                            color: 'white'
                                        }
                                    }}
                                >
                                    <MeetingRoomIcon />
                                </Avatar>
                                <Typography 
                                    component="h1" 
                                    variant="h4" 
                                    sx={{ 
                                        mb: 4,
                                        fontSize: { xs: '1.4rem', sm: '2.125rem' },
                                        color: 'var(--primaryPurple)',
                                        fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}
                                >
                                    Add Usher Gate
                                </Typography>
                                <Box 
                                    component="form" 
                                    onSubmit={handleSubmit} 
                                    sx={{ 
                                        width: '100%',
                                        '& .MuiTextField-root': {
                                            mb: 3
                                        }
                                    }}
                                >
                                    <MainInput
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="username"
                                        label="Username"
                                        name="username"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                backgroundColor: 'var(--platform-surface)',
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                }
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'var(--primaryPurple)',
                                                fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                    />
                                    <MainInput
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="gate"
                                        label="Assigned Gate"
                                        name="gate"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                backgroundColor: 'var(--platform-surface)',
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                }
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'var(--primaryPurple)',
                                                fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                    />
                                    <MainInput
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: 2,
                                                backgroundColor: 'var(--platform-surface)',
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--primaryPurple)',
                                                    borderWidth: '2px'
                                                }
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'var(--primaryPurple)',
                                                fontFamily: 'TickitTwo, Helvetica, Arial, sans-serif'
                                            }
                                        }}
                                    />
                                    <Box sx={{ 
                                        display: 'flex', 
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        justifyContent: 'center', 
                                        gap: 3, 
                                        mt: 4,
                                        pt: 3,
                                        borderTop: '1px solid #e0e0e0',
                                        '& .MuiButton-root': {
                                            width: { xs: '100%', sm: 'auto' }
                                        }
                                    }}>
                                        <Button
                                            onClick={handleClose}
                                            variant="outlined"
                                            size="large"
                                            sx={{ 
                                                borderRadius: 3,
                                                px: 4,
                                                py: 1.5,
                                                textTransform: 'none',
                                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                                fontWeight: 'bold',
                                                borderColor: '#e0e0e0',
                                                color: 'var(--tickit-gray500)',
                                                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                                                '&:hover': {
                                                    borderColor: '#e0e0e0',
                                                    backgroundColor: '#f5f5f5',
                                                    color: '#333'
                                                }
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="large"
                                            sx={{ 
                                                borderRadius: 3,
                                                px: 4,
                                                py: 1.5,
                                                textTransform: 'none',
                                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                                fontWeight: 'bold',
                                                backgroundColor: 'var(--primaryPurple)',
                                                fontFamily: 'TickitOne, Helvetica, Arial, sans-serif',
                                                boxShadow: '0 4px 16px rgba(95, 53, 184, 0.3)',
                                                '&:hover': {
                                                    backgroundColor: 'var(--secPurple)',
                                                    boxShadow: '0 6px 20px rgba(95, 53, 184, 0.4)',
                                                    transform: 'translateY(-2px)'
                                                },
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            Add Usher
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Paper>
                    </motion.div>
                )}
            </Box>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    wait: state?.wait,
});

const mapDispatchToProps = { createUsher, getUshers };

export default connect(mapStateToProps, mapDispatchToProps)(AddUsherModal);